module.exports = __webpack_public_path__ + "assets/media/licensesIcon.6b184dc6.svg";